function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.468,
    height: 14.286,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.806 4.7v-.414c0-.786.643-1.429 1.428-1.429h1.429c.789 0 1.428.64 1.428 1.429V4.7c.492.2.954.466 1.372.793l.357-.207a1.429 1.429 0 0 1 1.957.521l.714 1.243c.394.683.16 1.555-.521 1.95l-.357.207c.073.526.073 1.06 0 1.586l.357.214c.678.395.91 1.262.521 1.943l-.714 1.243a1.429 1.429 0 0 1-1.95.521l-.357-.214c-.42.332-.884.604-1.379.807v.407c0 .79-.64 1.429-1.428 1.429H9.234c-.789 0-1.428-.64-1.428-1.429V15.3a5.714 5.714 0 0 1-1.372-.793l-.357.207a1.429 1.429 0 0 1-1.957-.521l-.714-1.243A1.429 1.429 0 0 1 3.927 11l.357-.207a5.757 5.757 0 0 1 0-1.586l-.357-.214a1.429 1.429 0 0 1-.521-1.943l.714-1.243a1.429 1.429 0 0 1 1.95-.521l.357.214c.42-.332.884-.604 1.379-.807Zm-.8 2.186-.386.364-1.264-.729-.715 1.243 1.258.722-.122.521a4.3 4.3 0 0 0 0 1.986l.122.521-1.258.722.715 1.243 1.264-.729.386.364a4.286 4.286 0 0 0 1.714 1l.514.143v1.457h1.429v-1.457l.507-.143a4.286 4.286 0 0 0 1.721-1l.386-.364 1.264.729.715-1.243-1.257-.722.12-.521a4.3 4.3 0 0 0 0-1.986L14 8.486l1.257-.722-.715-1.243-1.264.729-.386-.364a4.286 4.286 0 0 0-1.714-1l-.514-.143V4.286H9.234v1.457l-.507.143a4.286 4.286 0 0 0-1.721 1zm2.943 5.971a2.857 2.857 0 1 1 0-5.714 2.857 2.857 0 0 1 0 5.714zm0-1.428a1.429 1.429 0 1 0 0-2.858 1.429 1.429 0 0 0 0 2.858z",
    transform: "translate(-3.214 -2.857)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearWhite);
export default __webpack_public_path__ + "static/media/gear-white.fcb9599253d55974ca39a2c90cd9f8bc.svg";
export { ForwardRef as ReactComponent };